"use client";

import { openSupport } from "@/lib/support";

type Props = {
  className: string;
  children: React.ReactNode;
};

export function ContactFooterLink({ className, children }: Props) {
  return (
    <button type="button" onClick={() => openSupport()} className={className}>
      {children}
    </button>
  );
}
